export const schoolPickerRoute = {
  path: 'school-picker',
  url: '/school-picker',
  loadChildren: () => import('../../../../shell/school-picker/school-picker.module').then(m => m.SchoolPickerModule),
};
